import React from 'react';

import TripSearchCriteria from './TripSearchCriteria';

function GolfTrips() {
  return (
    <>
      <div className="mx-auto">
        <div className="w-full mx-auto">
          {/*TripSearchCriteria*/}
          <TripSearchCriteria />
          {/*TripSearchResults - with sub component cards*/}
        </div>
      </div>
    </>
  );
}

export default GolfTrips;
